$(function ($) {
    "use strict";

    var $body = $(document.body);

    $('.module-navbar').each(function () {
        var $element = $(this);

        var $pushdown = $element.find('.menu-pushdown');
        var focusTrap = new FocusTrap($pushdown);

        var slideopt = { duration: 300 }; // needs to be equal with _module-navbar.scss !!

        var animating = false;
        $element.find('.hamburger').on('click', function () {
            if (!animating) {
                animating = true;
                var $btn = $(this);
                if ($btn.hasClass('open')) {
                    $pushdown.find('.menulevel').slideUp(slideopt);
                    $btn.removeClass('open');
                    $body.removeClass('navbar-open').css({ overflow: '' });
                    focusTrap.release();
                } else {
                    $pushdown.find('.menulevel:not(:last-of-type)').slideUp(slideopt);
                    $pushdown.find('.menulevel:last-of-type').slideDown(slideopt);
                    $btn.addClass('open');
                    $body.addClass('navbar-open').css({ overflow: 'hidden' });
                    focusTrap.keepFocus();
                }
                setTimeout(onFinish, slideopt.duration);
            }

            function onFinish() {
                animating = false;
            }
        });

        $element.find('.menulevel__back').on('click', function () {
            var $level = $(this).parents('.menulevel');
            $level.slideUp();
            $level.prev().slideDown();
            focusTrap.keepFocus();
        });

        $element.find('.navbar-overlay').on('click', function () {
            $element.find('.navbar-toggle').click();
        });

        function render() {
            if (window.scrollY > 1) { $element.addClass('fixed'); }
            else { $element.removeClass('fixed'); }
        }
        $(document).on('scroll', function () { render(); });
        render();
    });



    // helper to keep the focus inside a div.
    function FocusTrap($container) {
        this.$container = $container;

        $container
            .attr('tabindex', '0')
            .css({ outline: 'none' });
    }

    FocusTrap.prototype.keepFocus = function () {
        var _ = this;

        _.release();
        _.$container.focus();
        _.$focusTrap = $('<div focus-trap tabindex="0"></div>')
            .insertAfter(_.$container)
            .on('focus', function () {
                _.$container.focus();
            });
    };

    FocusTrap.prototype.release = function () {
        if (this.$focusTrap) {
            this.$focusTrap.remove();
            this.$focusTrap = null;
        }
    };


});